import React, { useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Planet } from 'react-kawaii';
import { clearAllFilters } from '../../actions/filtersActions';
import {
	H1, Button
} from '../base';
import media from '../base/media';

const StyledTitle = styled(H1)`
	margin-bottom: 3rem;
`;

const StyledPlanet = styled(Planet)`
	margin-bottom: 3rem;
`;

const StyledNoApartmentsFound = styled.div`
	text-align: center;
	padding: 5rem 0;

	${media.tablet`
		padding: 8rem 0;
	`}
`;

const ApartmentsListError = ({
	dispatch
}) => {
	const [mood, setMood] = useState('shocked');

	const onHover = (newMood) => {
		setMood(newMood);
	};

	const onClear = () => {
		dispatch(clearAllFilters());
	};

	return (
		<StyledNoApartmentsFound>
			<StyledPlanet size={220} mood={mood} color="#f0f0f0" />
			<StyledTitle>Engar íbúðir fundust...</StyledTitle>
			<Button
				onClick={onClear}
				onMouseEnter={onHover.bind(null, 'blissful')}
				onMouseLeave={onHover.bind(null, 'shocked')}>
				<span>Hreinsa val</span>
			</Button>
		</StyledNoApartmentsFound>
	);
};

export default connect(null)(ApartmentsListError);
